(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('reportTemplates', reportTemplates);

	reportTemplates.$inject = ['$rootScope', '$scope', '$timeout'];

	function reportTemplates($rootScope, $scope, $timeout) {
		var vm = this;

		$scope.siteId = globalConfig.factory.id;
		$scope.customerId = globalConfig.customer.id;
	}
})();